<template>
    <div class="prize-catalog">
        <div class="prize-catalog__image" @click="goToDetail(content.MAIN_PRODUCT.ID)">
            <img class="prize-catalog__image-content" :src="content.MAIN_PRODUCT.GALLERY[0]"
                 alt=""
            >
        </div>
        <div class="prize-catalog__container">
            <div class="prize-catalog__title" @click="goToDetail(content.MAIN_PRODUCT.ID)">
                {{ content.MAIN_PRODUCT.NAME }}
            </div>
            <div class="prize-catalog__price">
                {{ content.MAIN_PRODUCT.PRICE }} баллов
            </div>
            <div class="prize-catalog__button-container">
                <buttonRed v-if="!content.PRODUCTS" :disabled="disabled" style="width: 149px; height: 51px"
                           @click.native="!disabled ? addItemToBasket(content.MAIN_PRODUCT.ID) : ''" v-text="$t('В корзину')"
                />
                <buttonRed v-else :disabled="disabled" style="width: 149px; height: 51px"
                           @click.native="!disabled ? showModal = true : ''" v-text="$t('В корзину')"
                />
                <div v-if="point < 0 && error.id !== content.MAIN_PRODUCT.ID && content.MAIN_PRODUCT.REMAINDER !== 0"
                     class="prize-catalog__button-point"
                > Не хватает {{ point * -1 }} баллов
                </div>
                <div v-if="(content.MAIN_PRODUCT.REMAINDER === 0 && !content.PRODUCTS) || content.MAIN_PRODUCT.ID === error.id"
                     class="prize-catalog__button-point"
                >
                    Товара нет в наличии
                </div>
                <div v-if="MAX_COUNT_YEAR <= 0" class="prize-catalog__button-point">
                    Лимит по товару исчерпан
                </div>
            </div>
        </div>
        <Modal v-if="showModal" @close="showModal = false">
            <h3 slot="header">Выберите размер</h3>
            <div slot="body">
                <div>
                    <div class="detail__left-size-container">
                        <div
                            :class="content.MAIN_PRODUCT.REMAINDER > 0 ? 'detail__left-size-item' : 'detail__left-size-item disabled'"
                            @click="!disabled && content.MAIN_PRODUCT.REMAINDER > 0 ? addItemToBasket(content.MAIN_PRODUCT.ID) : ''"
                        >
                            {{ content.MAIN_PRODUCT.SIZE || content.MAIN_PRODUCT.EUSIZE }}
                        </div>
                        <div v-for="item in content.PRODUCTS" :key="item.ID"
                             :class="item.REMAINDER > 0 ? 'detail__left-size-item' : 'detail__left-size-item disabled'"
                             @click="!disabled && item.REMAINDER > 0 ? addItemToBasket(item.ID) : ''"
                        >{{ item.SIZE || item.EUSIZE }}
                        </div>
                    </div>
                </div>
            </div>
        </Modal>
    </div>
</template>

<script>
import buttonRed from '@/components/ui/buttons/button_red';
import Modal from './Prize_shop_item_modal.vue';
import {mapActions, mapGetters} from 'vuex';

export default {
  components: {buttonRed, Modal},
  props     : ['id', 'content'],
  data() {
    return {
      showModal: false,
    };
  },
  methods: {
    goToDetail(id) {
      this.$router.push({name: 'prize_detail', params: {id: id}});
    },
    ...mapActions('order/Basket', ['addBasket']),
    ...mapActions('order/Basket', ['getBasket']),
    ...mapActions('prize_shop', [
      'get_prizes',
    ]),
    addItemToBasket(content) {
      this.showModal = false;
      this.get_prizes();
      this.addBasket(content);
    },
  },
  computed: {
    ...mapGetters('profile/user', [
      'user',
    ]),
    MAX_COUNT_YEAR() {
      return this.content.MAIN_PRODUCT.MAX_COUNT_YEAR - (this.content.MAIN_PRODUCT.IN_BASKET_NOW + this.content.MAIN_PRODUCT.BUY_EARLY_PRODUCT);
    },
    disabled() {
      if (this.point < 0 || this.MAX_COUNT_YEAR <= 0) {
        return true;
      } else {
        return false;
      }
    },
    ...mapGetters('order/Basket', ['error']),
    point() {
      if (this.error.id === this.content.MAIN_PRODUCT.ID || (this.content.MAIN_PRODUCT.REMAINDER === 0 && !this.content.PRODUCTS)) {
        return -1;
      } else {
        return this.user.points - this.content.MAIN_PRODUCT.PRICE;
      }
    },
  },
};
</script>

<style scope lang="sass">
$desktop: 1200px
$tablet: 991px
$mobail: 767px
$sm-mobail: 576px
$font: FuturaFuturisC


.detail
  display: flex
  justify-content: space-between
  margin-top: 115px
  @media screen and (max-width: 960px)
    margin-top: 50px
    flex-wrap: wrap

  &__right
    width: 50%
    @media screen and (max-width: 960px)
      width: 100%
      padding: 0 15px

    &-img
      display: flex
      justify-content: center
      width: 100%
      max-width: 621px
      height: 509px
      margin: 0 0 24px 0

    &-slider
      display: flex
      justify-content: center
      @media screen and (max-width: 670px)
        width: 90%

      &-arrow
        width: 52px
        height: 50.78px
        background-color: #F8F8F8
        z-index: 2
        margin-top: 29px
        cursor: pointer

        &.right
          margin-left: -24px
          display: flex
          align-items: center
          justify-content: center
          transition: color 0.3s ease-in-out
          font-size: 20px
          font-weight: 500

          &:hover
            color: #E4183E

          &:before
            content: ">"


        &.left
          margin-right: -24px
          display: flex
          align-items: center
          justify-content: center
          transition: color 0.3s ease-in-out
          font-size: 20px
          font-weight: 500

          &:hover
            color: #E4183E

          &:before
            content: "<"


  &__left
    width: 40%
    @media screen and (max-width: 960px)
      width: 100%
      padding: 0 15px

    &-title
      font-size: 42px
      font-weight: 400
      line-height: 140%
      color: #4A4A4A

    &-desc
      margin: 24px 0 40px 0
      font-size: 24px
      line-height: 29px
      font-weight: 400
      color: #838688

    &-price
      margin: 40px 0
      color: #E4183E
      font-size: 48px
      line-height: 58px
      font-weight: 400

    &-size
      font-size: 16px
      line-height: 17px
      color: #4A4A4A
      margin: 40px 0 24px 0
      font-weight: 400

      &-container
        display: flex
        padding: 30px 0 15px 0
        flex-direction: row

      &-item
        width: 77px
        height: 38px
        display: flex
        justify-content: center
        align-items: center
        border: 1px solid #DEDEDE
        cursor: pointer
        margin: 0 6px
        transition: border 0.3s ease-in-out

        &:nth-child(1)
          margin: 0 6px 0px 0px

        &:hover
          border: 1px solid #FF718B


.prize-catalog
  display: flex
  flex-direction: column
  width: calc((100% / 3) - 24px)
  margin: 12px
  box-shadow: 0px 4px 30px -10px rgba(41, 59, 113, 0.2)
  @media screen and (max-width: $mobail)
    width: 100%
    align-items: center

  &__error
    margin: 20px 0 10px 0
    color: #e2173d

  &__button-container
    display: flex
    align-items: center
    flex-wrap: wrap

  &__button-point
    margin: 0 15px

  &__image
    width: 100%
    display: flex
    justify-content: center
    cursor: pointer

    & img
      height: 279px

  &__container
    margin: 24px
    display: flex
    justify-content: space-between
    flex-direction: column
    height: 100%

  &__title
    margin: 32px 0
    font-size: 24px
    height: 100%
    font-weight: 400
    line-height: 29px
    color: #4A4A4A
    cursor: pointer
    transition: 0.3s ease-in-out
    opacity: 1

    &:hover
      opacity: 0.75

    @media screen and (max-width: $desktop)
      font-size: 20px
    @media screen and (max-width: $mobail)
      font-size: 18px

  &__price
    color: #E4183E
    font-size: 24px
    line-height: 29px
    font-weight: 400
    margin: 24px 0
    @media screen and (max-width: $desktop)
      font-size: 18px
    @media screen and (max-width: $mobail)
      font-size: 16px

.disabled
  cursor: not-allowed !important
  border: 1px solid #DEDEDE
  color: #DEDEDE
  position: relative
  overflow: hidden
  &:hover
    border: 1px solid #DEDEDE !important

  &:before
    content: ''
    position: absolute
    display: block
    width: auto
    height: auto
    left: 0
    top: 0
    right: 0
    bottom: 0
    background: url('/icons/disabled-item.svg') no-repeat
    background-size: 100% 100%
</style>


